var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFullXs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8565 1.01149C10.2567 0.252874 9.5369 0 8.69718 0C7.85745 0 7.01772 0.252874 6.41792 1.01149L5.93807 1.51724L5.33827 1.01149C4.73846 0.252874 3.89873 0 3.05901 0C2.33924 0 1.49951 0.252874 0.899708 1.01149C-0.299903 2.27586 -0.299903 4.42529 0.899708 5.81609L1.37955 6.32184L5.93807 11L10.3766 6.32184L10.8565 5.81609C12.176 4.42529 12.176 2.27586 10.8565 1.01149Z",
    fill: "#e32323"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullXs);
export default __webpack_public_path__ + "static/media/full_xs.fe858e0eed581eb0eab54267100904ef.svg";
export { ForwardRef as ReactComponent };